const customerDetailsErros = {
    organisationEmpty: "Organization field is required.",
    organisationMaxChars: "Organization field should not be greater than 100 characters",
    websiteURLFormat: "The URL should be in valid format"
}

export { customerDetailsErros };